// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"88d30d67","455":"3be8e390","977":"6762520b"}[chunkId] + ".chunk.js";
};